import './_product-action-callouts.scss';
import component from './product-action-callouts';

export default component;
